import React from 'react';
import { Section } from '../ui/Section';
import { XCircle, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const failedStrategies = ['Estirar más (cuando ya duele)', 'Apretar una pelota antiestrés', 'Aguantar hasta que se pase', 'Tomar algo cuando ya estás en crisis', 'Ponerse una férula y rezar para no despertarse'];
  return <Section id="problem" background="navy" className="border-t border-[#2a3245]" data-id="element-108">
      <div className="text-center mb-12" data-id="element-109">
        <span className="text-[#d4af37] font-serif italic text-lg mb-2 block" data-id="element-110">
          La verdad
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-[#f5f0e8] mb-6" data-id="element-111">
          Tu noche necesita otra estrategia
        </h2>
        <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-112">
          Muchas mujeres intentan resolver la noche con herramientas "de día". Y
          luego piensan que "no funciona" porque su caso es peor.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10 items-center" data-id="element-113">
        <div className="bg-[#0f1419]/50 p-8 rounded-2xl border border-[#2a3245]" data-id="element-114">
          <h3 className="text-xl font-medium text-[#e85d5d] mb-6 flex items-center gap-2" data-id="element-115">
            <XCircle className="h-5 w-5" data-id="element-116" />
            Lo que has intentado sin éxito:
          </h3>
          <ul className="space-y-4" data-id="element-117">
            {failedStrategies.map((item, index) => <li key={index} className="flex items-start gap-3 text-gray-300" data-id="element-118">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#2a3245] flex-shrink-0" data-id="element-119" />
                <span data-id="element-120">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="space-y-6" data-id="element-121">
          <div className="flex items-start gap-4" data-id="element-122">
            <div className="p-3 rounded-full bg-[#d4af37]/10 text-[#d4af37]" data-id="element-123">
              <AlertCircle size={24} data-id="element-124" />
            </div>
            <div data-id="element-125">
              <h3 className="text-2xl font-serif font-bold text-[#f5f0e8] mb-2" data-id="element-126">
                No. No es tu culpa.
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-127">
                Lo que falla es el enfoque:{' '}
                <strong className="text-[#f5f0e8]" data-id="element-128">llegas tarde.</strong>
                <br data-id="element-129" />
                <br data-id="element-130" />
                Cuando intentas solucionar el dolor una vez que ya te despertó o
                cuando ya es insoportable, tu sistema nervioso ya está en alerta
                máxima.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}